import { cloud } from './lib/climbwriterCloud';

const form = document.querySelector<HTMLFormElement>('#cancellation-form')!;
const status = document.querySelector<HTMLParagraphElement>('#cancellation-status')!;
const receipt = document.querySelector<HTMLAnchorElement>('#cancellation-receipt')!;
const submit = form.querySelector<HTMLButtonElement>('button[type="submit"]')!;
const reason = form.elements.namedItem('reason') as HTMLTextAreaElement;
const kind = form.elements.namedItem('kind') as HTMLSelectElement;
kind.addEventListener('change', () => { reason.required = kind.value === 'extraordinary'; });
form.addEventListener('submit', async event => {
  event.preventDefault();
  if (submit.disabled || !form.reportValidity()) return;
  submit.disabled = true;
  status.textContent = 'Submitting your cancellation notice…';
  try {
    if (!cloud) throw new Error('Please email info@climbwriter.com. Online cancellation is temporarily unavailable.');
    const body = Object.fromEntries(new FormData(form).entries());
    const { data, error } = await cloud.functions.invoke('cancellation', { body });
    if (error || !data?.id) throw new Error('Your notice could not be confirmed. Please try again or email info@climbwriter.com.');
    status.textContent = `Cancellation notice received on ${new Date(data.receivedAt).toLocaleString('en-US')}. Reference: ${data.id}. ${data.emailSent ? 'A receipt has been emailed to you.' : 'Email delivery is pending; please download your receipt.'} We will confirm the effective date after matching your subscription.`;
    receipt.href = URL.createObjectURL(new Blob([data.receipt], { type: 'text/plain' }));
    receipt.download = `climbwriter-cancellation-${data.id}.txt`;
    receipt.hidden = false;
    form.hidden = true;
  } catch (error) {
    status.textContent = error instanceof Error ? error.message : 'Please email info@climbwriter.com.';
    submit.disabled = false;
  }
});
